import { configureStore } from "@reduxjs/toolkit";
import commandReducer from "./Store/commandSlice";

export const store = configureStore({
  reducer: {
    command: commandReducer,
  },
});